import { gql } from '@apollo/client';

export const ALL_SUBJECTS = gql`
  query AllSubjects {
    subjects {
      id
      name
      subjectGradeReference
      nationalCode
    }
  }
`;
